import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { MenuSection } from "../types/settings";
import { useMemo } from "react";
import { getMenuSections } from "../layouts/dashboard/config";
import { useTranslation } from "react-i18next";
import { selectComments } from "../store/comments/repository/selector";
import { getDocumentCount } from "../store/comments/useCases/getDocumentsCount/action";
import { getAnnoucementCount } from "../store/comments/useCases/getAnnoucementCount/action";

export const useTranslateNavSections = (): MenuSection[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { documentCount, annoucementCount } = useSelector(selectComments);

  useEffect(() => {
    dispatch(getDocumentCount());
    dispatch(getAnnoucementCount());
  }, []);

  return useMemo(
    () =>
      getMenuSections({
        t,
        documentCount,
        annoucementCount,
      }),
    [t, documentCount, annoucementCount]
  );
};
